import { DealXgSocketActions } from '../socket';
import { Actions } from '../actionTypes/actionTypes';
import type { RefreshDealRequestedAction, ShowDealRefreshModalAction } from './types';

export const showDealRefreshModal = (): ShowDealRefreshModalAction => ({
    type: DealXgSocketActions.SHOW_DEAL_REFRESH_MODAL
});

export const refreshDealRequested = (meta?: Record<string, any>): RefreshDealRequestedAction => ({
    type: DealXgSocketActions.REFRESH_DEAL_REQUESTED,
    meta
});

// Analytics-only marker; no reducer listens to it (dc-sci-094)
export const offerUpdatesRefreshClicked = () => ({
    type: Actions.REFRESH_OFFER_UPDATES_CDL
});
